import camelcaseKeys from 'camelcase-keys'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { i18n } from '@/locale'

export class Order {
  constructor (params = {}) {
    const { moment, stationId, guestId, orderLines, createdAt, externalIds, id, reference, sequence, serviceId } = camelcaseKeys(params)
    this.params = params
    this.moment = moment || null
    this.guestId = guestId || null
    this.sequence = sequence || null
    this.stationId = stationId || null
    this.createdAt = createdAt || null
    this.reference = reference || null
    this.serviceId = serviceId || null
    this.serviceId = serviceId || null
    this.externalIds = externalIds || null
    this.orderLines = orderLines ? orderLines.map((orderLine) => {
      return new OrderLine(orderLine)
    }) : []
  }
}

export class OrderLine {
  constructor (params = {}) {
    const { id, parentOrderLine, orderLineType, itemId, name, localizedName, taxGroupId, quantity, price, value, addedAt, itemEntity } = camelcaseKeys(params, { deep: true })
    this.id = id || null
    this.itemId = itemId || null
    this.addedAt = addedAt || null
    this.itemEntity = itemEntity || null
    this.quantity = quantity || null
    this.itemEntity = itemEntity || null
    this.taxGroupId = taxGroupId || null
    this.orderLineType = orderLineType || null
    this.parentOrderLine = parentOrderLine || null
    this.value = typeof value === 'number' ? value : null
    this.price = price
      ? Array.isArray(price)
        ? price.map((price) => new Price(price))
        : price.priceItems.map((price) => new Price(price))
      : []
    this.name = localizedName
      ? getTextValue(localizedName)
      : itemEntity === 'RESERVATION_METHOD'
        ? i18n.t('activity_reservation.name')
        : name
  }
}
export class Price {
  constructor (params = {}) {
    const { amount, taxes, currency, currencyId } = params ? camelcaseKeys(params) : {}
    this.amount = typeof amount === 'number' ? amount : null
    this.currency = currency || null
    this.currencyId = currency ? currency.id : currencyId || null
    this.taxes = taxes || []
  }
}
